import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Icon } from '@unite-us/ui';
function VoiceMailOk(_ref) {
  var isVoicemailOK = _ref.isVoicemailOK,
    contactMethods = _ref.contactMethods;
  var isPhoneSelected = _includesInstanceProperty(_).call(_, contactMethods, 'phone');
  return /*#__PURE__*/React.createElement("div", {
    className: "voicemail-ok"
  }, isPhoneSelected && /*#__PURE__*/React.createElement("div", {
    className: "voicemail-check"
  }, isVoicemailOK ? /*#__PURE__*/React.createElement("div", {
    className: "flex font-bold"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "IconCheckCircle",
    color: "#1CCA21",
    "data-testid": "icon-voicemail-ok"
  }), /*#__PURE__*/React.createElement("div", {
    className: "ml-1"
  }, "Okay to leave a voicemail.")) : /*#__PURE__*/React.createElement("div", {
    className: "flex font-bold"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "IconTimesCircle",
    color: "#CF2A2A",
    "data-testid": "icon-voicemail-not-ok"
  }), /*#__PURE__*/React.createElement("div", {
    className: "ml-1"
  }, "Not okay to leave a voicemail."))));
}
VoiceMailOk.propTypes = {
  contactMethods: PropTypes.array.isRequired,
  isVoicemailOK: PropTypes.bool.isRequired
};
export default VoiceMailOk;
//# sourceMappingURL=VoiceMailOk.js.map